import script from "./StepsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsView.vue?vue&type=script&setup=true&lang=js"

import "./StepsView.vue?vue&type=style&index=0&id=4b510d21&lang=css"

const __exports__ = script;

export default __exports__